import React, {Component} from 'react';
import MyContextProvider from './Actions/UAuth';
import Home from './components/Home'

class App extends Component {
  render(){
  return (
      <MyContextProvider>
          <Home/>
      </MyContextProvider>
  );
  }
}
export default App; 